// OutboxMessage.js
import { connect } from 'react-redux';

import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import getMessageData from '../selector/getMessageData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import fetchMediaMenifestOfMessage from '../action/fetchMediaMenifestOfMessage.js';
import OutboxMessage from '../component/OutboxMessage.jsx';
import getMessageThumbnail from '../selector/getMessageThumbnail.js';
import getAssetData from '../selector/getAssetData.js';
import fetchDrmLicenseAvailability from '../action/fetchDrmLicenseAvailability.js';

import { getUserPicture, MediaAssetFormat } from '../resource/getMediaAsset.js';

const mapStateToProps = (state, ownProps) => {
  const { messageId } = ownProps;
  const userId = getMessageData(state, messageId, 'sender');
  const unlockPrice = getMessageData(state, messageId, 'unlockPrice');
  const assetIds = getMessageData(state, messageId, 'assetIds');
  const assetId = assetIds?.[0];
  const meId = getMeData(state, 'id');
  const meUsername = getMeData(state, 'username');

  return {
    userAvatarSrc: getUserPicture({
      userId,
      meId,
      size: 128,
      format: MediaAssetFormat.JPG,
    }).href,
    isAuthed: !!meId,
    mediaType: assetId
      ? getAssetData(state, [assetId], 'contentType')
      : getMessageData(state, messageId, 'mediaType'),
    title: getMessageDataWithVariable(
      state,
      messageId,
      'title',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    storyCaption: getMessageDataWithVariable(
      state,
      messageId,
      'captionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    expiresAtUnix: getMessageData(state, messageId, 'expiresAtUnix'),
    unlockPrice,
    thumbnail: getMessageThumbnail(
      state,
      messageId,
      '',
      '256x256',
      'jpg',
      unlockPrice ? '' : 'clear'
    ),
    username: getUserData(state, userId, 'username'),
    canViewMedia: getMessageData(state, messageId, 'canViewMedia'),
    shouldFetchMessageTranslation: true, // For withFetchTranslation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMediaMenifestOfMessage: ({ messageId }) =>
      dispatch(fetchMediaMenifestOfMessage({ id: messageId })),
    fetchDrmLicenseAvailability: ({ messageId, keySystem }) =>
      dispatch(fetchDrmLicenseAvailability({ messageId, keySystem })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OutboxMessage);
